// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

/** @typedef {{
  name: string,
  type: string
} & React.InputHTMLAttributes<HTMLInputElement>} RawTextInputPropsType */

/** @type { StatelessComponent<RawTextInputPropsType> } */
const RawTextInput = ({ name, type = 'text', ...otherInputProps }) => (
  <input
    name={name}
    id={name}
    type={type}
    className="input-large"
    {...otherInputProps} // You can override id, className, etc.
  />
);

RawTextInput.displayName = 'RawTextInput';

const TextInput = connectFormComponentToReduxForm(wrapFormComponentWithError(RawTextInput));

export { TextInput, RawTextInput };

const RawTextField = wrapFormComponentWithLabelAndError(RawTextInput);
RawTextField.displayName = 'RawTextField';

export { RawTextField };

const TextField = connectFormComponentToReduxForm(RawTextField);
TextField.displayName = 'TextField';

export default TextField;
